exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__flex___1XqFN{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.styles__flex___1XqFN>div{-ms-flex:1 0 50%;flex:1 0 50%}.styles__flex___1XqFN>div:first-child{-ms-flex:0 1 100%;flex:0 1 100%}", "", {"version":3,"sources":["/./src/routes/SendCampaignMessage/containers/styles.css"],"names":[],"mappings":"AAAA,sBACI,oBAAA,aAAc,0BACd,sBAAuB,mBACvB,eAAgB,qBAChB,uBAAwB,sBACxB,kBAAoB,CACvB,0BAGG,iBAAA,YAAc,CACjB,sCAGG,kBAAA,aAAe,CAClB","file":"styles.css","sourcesContent":[".flex {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n\n.flex>div {\n    flex: 1 0 50%;\n}\n\n.flex>div:first-child {\n    flex: 0 1 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"flex": "styles__flex___1XqFN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/routes/SendCampaignMessage/containers/styles.css
// module id = 2671
// module chunks = 0